module.exports = __webpack_public_path__ + "media/images/cz250-fecc3f02489daf71aa88bf2f5694d7bf.svg";